import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserBloc } from '@kp/user/user.bloc';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-user-email',
  templateUrl: './user-email.component.html',
  styleUrls: ['./user-email.component.scss'],
})
export class UserEmailComponent implements OnInit, OnDestroy {
  constructor(public userBloc: UserBloc) {}

  private _destroy$ = new Subject<void>();

  @Input() emailKey = 'email';
  @Output() email = new EventEmitter<string>();

  ngOnInit(): void {
    this.userBloc.existingUserEmail$
      .pipe(takeUntil(this._destroy$))
      .subscribe((existingUserEmail) => this.email.emit(existingUserEmail));
    this.userBloc.getUserEmail(null, this.emailKey);
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
